import { Box, styled, Typography } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";



export const BoxContainerStyled = styled(Box, {
    label: "OrderOffer-BoxContainerStyled",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
}));

export const BoxNotificationStyled = styled(Box, {
    label: "OrderOffer-BoxNotificationStyled",
})(({ theme }) => ({
    display: "flex",
    alignContent: "center",
    paddingBottom: "5px",
}));

export const TypographyNotificationStyled = styled(Typography, {
    label: "OrderOffer-TypographyNotificationStyled",
})(({ theme }) => ({
   paddingLeft: "5px"
}));

export const SellConditionsContainer = styled(Box, {
    label: "OrderOffer-SellConditionsContainer",
})(({ theme }) => ({
    display: 'flex',
    alignItems:'center',
    marginTop: -9,
  'p':{
    fontSize: 12,
    fontWeight: StyleguideSavioFonts.bold,
    color: StyleguideSavioColors.mainBlue,
    textTransform: 'uppercase',
  },
  'button':{
    marginLeft: 10,
    padding:5,
  }
}));
